module.exports = __webpack_public_path__ + "static/img/card_btn_love.5d76271a.png";